module.exports = __webpack_public_path__ + "static/media/work6.83073357.jpg";